import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiService } from '../services/apiService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored user/token on mount
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (storedUser && token) {
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const data = await apiService.login(email, password);
    setUser(data.user);
    return data;
  };

  const googleLogin = async (token) => {
    const data = await apiService.googleLogin(token);
    setUser(data.user);
    return data;
  };

  const register = async (email, password, name) => {
    const data = await apiService.register(email, password, name);
    // Only log in if we got a token/user back directly (backward compatibility)
    if (data.token && data.user) {
      setUser(data.user);
    }
    return data;
  };

  const logout = () => {
    apiService.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, googleLogin, register, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
